export default __webpack_public_path__ + "static/media/login-bg-44.efa69cc4.jpg";